


































































































































































































































































































































import Vue from "vue";
import store, { BankStatementStore } from "../services/BankStatementStore";
import { bankStatementDefaultProps } from "../models/BankStatement";
import bStore, { BankStore } from "../../bank/services/BankStore";
import { NumericTextBox } from "@progress/kendo-vue-inputs";
import MoneyInput from "@/components/MoneyInput.vue";
import BankStatementPicturePage from "./BankStatementPicture.vue";
import dayjs from "dayjs";
import configuration, { AppConfiguration } from "@/models/Configuration";
import { ValidationFunc } from "@/models/Validation";
import DateInput from "@/components/DateInput.vue";
import SpecialDimensionButton from "@/components/SpecialDimensionButton.vue";
import BankStatementApi from "../services/BankStatementApi";
import ConfirmationBox from "@/components/ConfirmationBox.vue";
import BankDocByInvoices from "./BankDocByInvoices.vue";
import eventBus from "@/services/eventBus";
import { t } from "@/plugins/i18n";
import auth from "@/services/auth";

interface Data {
  store: BankStatementStore;
  bStore: BankStore;

  configuration: AppConfiguration;
  dateRule: Array<ValidationFunc>;
  valid: boolean;
  confirmation: boolean;
  wrongConfirmation: boolean;
  creatingDocFromInvoice: boolean;
  openRateEditing: boolean;
  newOpenRate: number;
  loadedStatement: object | null;
}

interface Methods {
  save(): void;
  cancel(): void;
  bankCodeChanged(): void;
  onInput(value: Date): void;
  loadCloseRate(): void;
  loadLastBalance(): void;
  close(): void;
  closeInner(updateBalance: boolean): void;
  reopen(): void;
  setWrong(): void;
  startOpenRateEdit(): void;
  saveOpenRate(): void;
}

interface Computed {
  statusName: string;
  accountingStatusName: string;
  bankName: string;
  hasOpenRatePermission: boolean;
  canEditOpenRate: boolean;
  isDisabled: boolean;
  isWrongDisabled: boolean;
  isReopenDisabled: boolean;
  isTechnicalBank: boolean;
  balanceAll: number;
  defaultCurrency: string;
  edateStatement: Date;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  async beforeMount() {
    store.loadBankStatuses();
    store.loadBankAccountStatuses();

    if (this.store.bankStatement.id > 1){
      await this.store.loadBankDocumentsByStatementId(
        this.store.bankStatement.id
      );

      if (this.store.bankStatement.openRate == 0){
        this.loadCloseRate();
      }
    }
  },

  components: {
    NumericTextBox,
    MoneyInput,
    BankStatementPicturePage,
    DateInput,
    ConfirmationBox,
    BankDocByInvoices,
    SpecialDimensionButton
  },

  data() {
    return {
      edate: new Date(),
      store,
      bStore,
      configuration,
      dateRule: [
        (v: Date | string) => !!v || t("KotelezoKitolteni"),
        (v: Date | string) =>
          (v && dayjs(v).toDate() >= dayjs("2016-06-15").toDate()) ||
          t("BankStatement_NemLehetRegebbiADatumMint"),
        (v: Date | string) =>
          (v && dayjs(v).toDate().getDate() >= dayjs().toDate().getDate()) ||
          t("BankStatement_NemLehetAMaiNapnalKesobbi"),
      ],
      valid: false,
      confirmation: false,
      wrongConfirmation: false,
      creatingDocFromInvoice: false,
      openRateEditing: false,
      newOpenRate: 0,
      loadedStatement: null,
    };
  },

  computed: {
    defaultCurrency(){
      return (configuration.sysParams.defaultCurrency as any).value;
    },

    balanceAll(){
      if (this.store.bankStatement.currency != this.defaultCurrency){
        return this.store.bankDocuments.filter(x => x.status.toLocaleLowerCase() != "rontott").map(x => x.bankStatementItem.currAmount * (x.bankStatementItem.crediting ? 1 : -1)).reduce((sum, x) => sum += x, 0) + this.store.bankStatement.openBalance;
      }

      return this.store.bankDocuments.filter(x => x.status.toLocaleLowerCase() != "rontott").map(x => x.bankStatementItem.amount * (x.bankStatementItem.crediting ? 1 : -1)).reduce((sum, x) => sum += x, 0) + this.store.bankStatement.openBalance;
    },

    isDisabled(){
      return this.store.bankStatement.status == 3 || this.store.bankStatement.status == 4 || this.store.bankStatement.isReopen;
    },

    hasOpenRatePermission(){
      return auth.menuPermissions.find((x) => x.name == "BANKOPENRATEMOD")?.isGranted ?? false;
    },

    // K2D M_NYITO_MOD: nyitott devizás kivonat, amíg nincs feldolgozás alatti/lezárt tétele
    canEditOpenRate(){
      return this.store.bankStatement.id > 1
        && this.store.bankStatement.status == 2
        && this.store.bankStatement.currency != this.defaultCurrency
        && !this.store.bankDocuments.some(x => x.bankStatementItem.status == 2 || x.bankStatementItem.status == 3);
    },

    isTechnicalBank(){
      return this.store.partBanks.find(x => x.id == this.store.bankStatement.bank)?.technical ?? false;
    },

    isReopenDisabled(){
      if (this.store.bankStatement.status != 3){
        return true;
      }

      // Technikai banknál (0 egyenleg) bármelyik kivonat visszanyitható,
      // devizás és főkönyvi megkötés nélkül
      if (this.isTechnicalBank){
        return false;
      }

      const accountStatus = this.store.bankStatement.accountStatus;
      const isSent = accountStatus == 4 || accountStatus == 6 || accountStatus == 9 || accountStatus == 10;

      // Csak lezárt, főkönyvbe még fel nem adott, HUF-os kivonat nyitható vissza
      return isSent
        || this.store.bankStatement.currency != this.defaultCurrency;
    },

    isWrongDisabled(){
      const accountStatus = this.store.bankStatement.accountStatus;
      const isSent = accountStatus == 4 || accountStatus == 6 || accountStatus == 9 || accountStatus == 10;
      const allItemsWrong = this.store.bankDocuments.every(x => x.status.toLocaleLowerCase() == "rontott");

      return this.store.bankStatement.id < 2
        || this.store.bankStatement.status == 3
        || this.store.bankStatement.status == 4
        || (isSent && !this.isTechnicalBank) // technikai banknál a főkönyvi feladást nem kell ellenőrizni
        || !allItemsWrong;
    },

    statusName() {
      return this.store.bankStatuses.find(x => x.id == this.store.bankStatement.status)?.name ?? "";
    },
    accountingStatusName() {
      return this.store.bankAccountStatuses.find(x => x.id == this.store.bankStatement.accountStatus)?.name ?? "";
    },
    bankName() {
     return this.store.partBanks.find(
          (x) => x.id == this.store.bankStatement.bank
        )?.bank ?? "";
    },
    edateStatement(){
      return this.store.bankStatement.edate;
    }
  },

  methods: {
    async closeInner(updateBalance){
      this.confirmation = false;

      if (!updateBalance){
        return;
      }

      await this.store.closeBankStatement(true);
    },

    async setWrong(){
      this.wrongConfirmation = false;
      await this.store.wrongBankStatement();
    },

    async reopen(){
      const result = await this.store.reopenBankStatement();
      if (result) {
        eventBus.$emit("success", t("BankStatement_SikeresVisszanyitas"));
      }
    },

    startOpenRateEdit(){
      this.newOpenRate = this.store.bankStatement.openRate;
      this.openRateEditing = true;
    },

    async saveOpenRate(){
      if (!this.newOpenRate || this.newOpenRate <= 0 || this.newOpenRate == 1){
        eventBus.$emit("error", t("BankStatement_HibasNyitoArfolyam"));
        return;
      }

      try {
        const result = await this.store.setOpenRate(this.newOpenRate);
        if (result) {
          this.openRateEditing = false;
          eventBus.$emit("success", t("BankStatement_NyitoArfolyamModositva"));
        }
      } catch {
        // a hibaüzenetet a checkResponse már megjelenítette
      }
    },

    async close(){
      console.log((Math.round(this.balanceAll * 100) / 100));

      if ((Math.round(this.balanceAll * 100) / 100) != this.store.bankStatement.closeBalance){
        this.confirmation = true;
      } else {
        this.closeInner(true);
      }
    },

    async loadCloseRate(){
      if (this.store.bankStatement.bank > 1 && this.store.bankStatement.currency != 'HUF') {
        this.store.bankStatement.openRate = await BankStatementApi.getLastStatementRate(this.store.bankStatement.bank, this.store.bankStatement.id, this.store.bankStatement.edate);
      } else {
        this.store.bankStatement.openRate = 1;
      }
    },

    async loadLastBalance(){
      if (this.store.bankStatement.bank > 1 /*&& this.store.bankStatement.openBalance == 0*/){
        this.store.bankStatement.openBalance = await BankStatementApi.getLastBalance(this.store.bankStatement.bank, this.store.bankStatement.id, this.store.bankStatement.edate);
      }
    },

    onInput(value: Date) {
      if (value) {
        this.store.bankStatement.edate = value;
      } else {
        this.store.bankStatement.edate = new Date;
      }
    },

    cancel() {
      this.store.bankStatement = { ...bankStatementDefaultProps };
      this.$router.push(`/bank-statement`);
    },

    async save() {
      const id = Number(await this.store.save());
      if (id > 1) {
        this.$router.push(`/bank-statement/create/${id}/head`); //todo
      }
    },

    bankCodeChanged() {
      this.store.bankStatement.currency =
        this.store.partBanks.find(
          (x) => x.id == this.store.bankStatement.bank
        )?.currency ?? "-";

      this.store.bankStatement.bank =
        this.store.partBanks.find(
          (x) => x.id == this.store.bankStatement.bank
        )?.id ?? 1;

      this.loadCloseRate();
      this.loadLastBalance();
    },
  },

  watch:{
    edateStatement: function(){
      // Meglévő kivonat betöltésekor a tárolt (akár kézzel módosított) nyitó árfolyam marad,
      // az előző záró árfolyamot csak dátumváltáskor vagy hiányzó árfolyamnál kérjük le
      const isLoad = this.store.bankStatement !== this.loadedStatement;
      this.loadedStatement = this.store.bankStatement;
      this.openRateEditing = false;

      if (!isLoad || this.store.bankStatement.id < 2 || !this.store.bankStatement.openRate) {
        this.loadCloseRate();
      }
      this.loadLastBalance();
    }
  },
});
